import { UiPricingPlanModel } from "../../../models";
import {
    Description,
    Item,
    Price,
    PriceAppend,
    PriceDetail
} from "../UiPricingGrid.styles";

export type DefaultPlanProps = {
    model: UiPricingPlanModel;
    index: number;
    planCount: number;
};

export const DefaultPlan = ({ model, index, planCount }: DefaultPlanProps) => {
    const {
        highlight,
        description,
        beforePrice,
        afterPrice,
        beforeSmallPrice,
        afterSmallPrice
    } = model.content;

    return (
        <>
            <Item
                lgOrder={index + planCount * 1}
                highlight={highlight}
                first={index === 0}
                show={true}
            >
                <Price>
                    <PriceAppend>{beforePrice}</PriceAppend>0
                    <PriceAppend>{afterPrice}</PriceAppend>
                </Price>
                {(beforeSmallPrice || afterSmallPrice) && (
                    <PriceDetail>
                        {beforeSmallPrice}
                        {afterSmallPrice}
                    </PriceDetail>
                )}
            </Item>
            <Item
                lgOrder={index + planCount * 2}
                highlight={highlight}
                first={index === 0}
                show={true}
            >
                <Description>{description}</Description>
            </Item>
        </>
    );
};
